export default {
  form: {
    bank_account_number: {
      label: 'Numéro de compte',
      placeholder: 'DE01101234567891234567',
    },
    bank_routing_number: {
      label: 'Numéro de routage',
      placeholder: '110000000',
    },
    bank_country: {
      label: 'Pays',
      placeholder: 'Allemagne',
    },
    bank_statement_descriptor: {
      label: 'Libellé de relevé',
      placeholder: 'Nom du restaurant',
      tooltip: 'Ce nom apparaîtra sur les relevés bancaires des clients',
    },
  },
  buttons: {
    next: 'Suivant',
    back: 'Retour',
    use_test_data: 'Utiliser des données de test',
  },
  test_data_hint: 'Compte bancaire de test accepté par {{gateways}}',
  read_only_warning:
    'Les informations bancaires ne peuvent être modifiées que par notre équipe. Pour les mettre à jour, veuillez contacter le support.',
};
